module.exports = __webpack_public_path__ + "static/media/DialIn-Logo@3x.fc787810.png";